import { Modal } from "@similarweb/ui-components";

import {
    MODAL_MAX_WIDTH,
    MODAL_WIDTH,
} from "app/pages/activation/components/HomeWithData/Projects/ProjectsListModal/constants";
import { ProjectsList } from "app/pages/activation/components/ProjectsList/ProjectsList";
import { useHomeContext } from "app/pages/activation/context/Home/HomeContext";

export type ProjectsListModalSchema = {
    isOpen: boolean;
    onClose: () => void;
    onClickCreateProject: () => void;
};

export const ProjectsListModal = ({ isOpen, onClose, onClickCreateProject }: ProjectsListModalSchema) => {
    const { projects, isError, isActivationLoading, isAllAvailableReturned, getAllData } = useHomeContext();

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            shouldCloseOnOverlayClick
            customStyles={{
                content: {
                    width: MODAL_WIDTH,
                    maxWidth: MODAL_MAX_WIDTH,
                    overflow: "hidden",
                },
            }}
            data-automation="projects-list-modal"
        >
            <ProjectsList
                data={projects}
                isError={isError}
                isLoading={isActivationLoading}
                isAllAvailableReturned={isAllAvailableReturned}
                onClickCreateProject={onClickCreateProject}
                getAllData={getAllData}
            />
        </Modal>
    );
};
